export default __webpack_public_path__ + "static/media/ionic.d2050eeb.svg";